import { getCertAccessView, getCertAccessBtnSubmit, showCertAccessError, hideCertAccessError } from './getCertAccessView.js';
import progressBar from '../../../../shared/DOM/progressBar.js';
import { disableLanguage } from '../../../../shared/DOM/disableLanguage.js';
import { getTargetViewName } from '../../../../shared/DOM/getTargetViewName.js';
import { getUrlParamsBasic } from '../../api/registerSession.js';
import { redirectWithGet } from '../../../../shared/api/redirect/redirect.js';

export function renderCertAccess(loginParams, loginForm) {
  const eForm = document.getElementById('form-login');

  eForm.render({
    value: {
      domain: loginForm.domain || loginParams.domain,
    },
    view: getCertAccessView(),
  });

  createCertAccessFooter();

  // #activate
  hideCertAccessError();

  initCertAccess();

  /////////////////////////////

  function initCertAccess() {
    disableLanguage();

    eForm.addEventListener('keyup', (event) => {
      if (event.key === 'Enter' && !!getCertAccessBtnSubmit()) {
        submitCertAccessForm();
      }
    });

    document.body.addEventListener('click', (event) => {
      const target = getTargetViewName(event);

      if (target === 'btnCertSubmit') {
        submitCertAccessForm();
      } else if (target === 'btnBack') {
        cancelCertAccessForm();
      }
    });
  }

  // eBtnBack
  function cancelCertAccessForm() {
    redirectLoginForm(loginParams);
  }

  // eBtnSubmit
  async function submitCertAccessForm() {
    const eBtnSubmit = getCertAccessBtnSubmit();

    if (!eBtnSubmit || eBtnSubmit.state === 'loading') {
      return;
    }

    try {
      eBtnSubmit.state = 'loading';
      progressBar.loading();

      const { domain } = eForm.value;

      // Exit error
      if (!domain) {
        throw new Error('login.domain_error');
      }

      const url = loginParams.urlCert;
      const urlParams = new URLSearchParams({ domain, custom: true });

      // Validamos el grupo: certAccess se activa con custom por lo que llega al login con domain y group
      if (loginParams.domain === domain && loginParams.group) {
        urlParams.set('group', loginParams.group);
      }

      redirectWithGet(`${url}?${urlParams}`);

      // No finalizamos lo dejamos en progress no sabemos lo que puede tardar la redirección...
    } catch (e) {
      eBtnSubmit.state = 'rejected';
      progressBar.rejected();
      showCertAccessError(e.message);
    }
  }
}

function createCertAccessFooter() {
  document.getElementById('container-footer').innerHTML = `<footer class="container--footer">
    <ewc-toolbar>
      <ewc-button icon="arrow-left" icon-rtl view-name="btnBack" label="${edicom.locale.translate('global.back')}" no-responsive></ewc-button>
    </ewc-toolbar>
  </footer>`;
}

function redirectLoginForm(loginParams) {
  const urlParams = getUrlParamsBasic(loginParams);
  return redirectWithGet(`/login?${urlParams}`);
}
